import { gsap } from "gsap/all"

export class LoadingScreen {
  constructor() {
    this.loadingScreenContainer = document.querySelector(".loading-screen")
  }

  fadeOut() {
    //?Values can be tweaked later for better timings
    let duration = 2

    setTimeout(() => {
      gsap.to(this.loadingScreenContainer, {
        opacity: 0,
        duration: duration,
        ease: "power1.inOut",
      })

      setTimeout(() => {
        // console.log("Loading screen deleted");
        this.loadingScreenContainer.remove()
      }, duration * 1000 + 500)
    }, 1000)
  }
}
